import { render, staticRenderFns } from "./DocumentoLivroCaixa.vue?vue&type=template&id=5ae85e32&"
import script from "./DocumentoLivroCaixa.vue?vue&type=script&lang=js&"
export * from "./DocumentoLivroCaixa.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoLivroCaixa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports